import React, { useState, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { H1 } from "../../common/H1"
import { LabeledSelect } from "../../common/LabeledSelect"
import { SelectAutocomplete } from "../../common/SelectAutocomplete"
import { Button } from "../../common/Button"
import { downloadPackageDebitReport } from "../../../actions"

import "./style.scss"

const reportHeader = 'דו"ח חיובי חבילות'
const monthLabel = "בחר חודש"
const yearLabel = "בחר שנה"
const orderTypeLabel = "בחר סוג הזמנה"

const startYear = 2021

const setYearList = () => {
  let years = []
  let now = new Date()
  now = now.getFullYear()
  for (var i = startYear; i <= now; i++) {
    years[i] = i
  }
  return years
}

const setMonthList = () => {
  let monthNames = [
    "ינואר",
    "פברואר",
    "מרץ",
    "אפריל",
    "מאי",
    "יוני",
    "יולי",
    "אוגוסט",
    "ספטמבר",
    "אוקטובר",
    "נובמבר",
    "דצמבר",
  ]
  let month = []
  for (var i = 0; i < monthNames.length; i++) {
    month[i + 1] = monthNames[i]
  }
  return month
}

const initMonth = () => {
  let now = new Date()
  let month = now.getMonth()
  if (month === 0) {
    month = 12
  }
  return month
}

const initYear = () => {
  let now = new Date()
  let year = now.getFullYear()
  if (now.getMonth() === 0) {
    year--
  }
  return year
}

const PackageDebitReport = () => {
  const dispatch = useDispatch()
  const { authenticated, userData } = useSelector((state) => state.users)
  const { externalMiniBoTypeId } = userData
  const [selectedMonth, setSelectedMonth] = useState(initMonth())
  const [selectedYear, setSelectedYear] = useState(initYear())
  const [selectedOrderType, setSelectedOrderType] = useState(null)
  const [selectedOrderTypeItem, setSelectedOrderTypeItem] = useState({})
  const [orderTypeOptions, setOrderTypeOptions] = useState([])

  const [monthOptions] = useState(setMonthList())
  const [yearOptions] = useState(setYearList())

  useEffect(() => {
    if (!authenticated) {
      this.props.history.push("/")
    }
  }, [authenticated])

  useEffect(() => {
    if (!externalMiniBoTypeId) return

    let options = []
    switch (externalMiniBoTypeId) {
      case 1:
        options = [
          { label: "משלוחים", value: 8 },
          { label: "החזרות", value: 31 },
        ]
        break
      case 3:
        options = [{ label: "לוקר ללוקר", value: 5 }]
        break
      default:
        options = []
    }

    setOrderTypeOptions(options)

    if (options.length > 0) {
      setSelectedOrderTypeItem(options[0])
      setSelectedOrderType(options[0].value)
    }
  }, [externalMiniBoTypeId])

  const onDataChange = (property, value) => {
    if (property === "selectedMonth") setSelectedMonth(value)
    if (property === "selectedYear") setSelectedYear(value)
    if (property === "selectedOrderType") {
      setSelectedOrderType(value.value)
      setSelectedOrderTypeItem(value)
    }
  }

  const onDownloadClick = (event) => {
    event.preventDefault()

    dispatch(
      downloadPackageDebitReport(selectedMonth, selectedYear, selectedOrderType)
    )
  }

  return (
    <div className="packageDebitReport">
      <H1 className="reports-section-header" title={reportHeader} />
      <form onSubmit={onDownloadClick}>
        <div className="form-group">
          <div className="date-wrapper">
            <SelectAutocomplete
              placeholder="סוג הזמנה"
              items={orderTypeOptions}
              value={selectedOrderTypeItem}
              defaultValue={orderTypeOptions ? orderTypeOptions[0] : null}
              onChangeHandler={(e) => onDataChange("selectedOrderType", e)}
            />
          </div>
          <div className="date-wrapper">
            <LabeledSelect
              extraClass={"label-box"}
              labelText={monthLabel}
              id="month"
              options={monthOptions}
              value={selectedMonth}
              emptyOption={false}
              onChange={(e) => onDataChange("selectedMonth", e.target.value)}
            />
            <LabeledSelect
              extraClass={"label-box"}
              labelText={yearLabel}
              id="year"
              options={yearOptions}
              value={selectedYear}
              emptyOption={false}
              onChange={(e) => onDataChange("selectedYear", e.target.value)}
            />
          </div>
        </div>
        <div className="btn-download-wrapper">
          <Button type="submit">הורד</Button>
        </div>
      </form>
    </div>
  )
}

export default PackageDebitReport
